import { Badge } from '@tempo-io/sui-badge';
import { Magic } from '@tempo-io/sui-icons';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@tempo-io/sui-tooltip';
import { useTranslation } from 'react-i18next';

export const ImputedBadge = () => {
  const { t } = useTranslation();
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="ai"
            rounded="full"
            aria-label={t(($) => $.adaptivePlanner.aiImputed.badge.tooltip)}
            data-testid="imputed-badge"
          >
            <Magic className="h-3 w-3 shrink-0" />
            {t(($) => $.adaptivePlanner.aiImputed.badge.label)}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>{t(($) => $.adaptivePlanner.aiImputed.badge.tooltip)}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
